import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=6a9ab06c&scoped=true&"
import script from "./ProcessCOPO.vue?vue&type=script&lang=js&"
export * from "./ProcessCOPO.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=6a9ab06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ab06c",
  null
  
)

export default component.exports